import React, { useState,forwardRef,useImperativeHandle } from "react";
import { useNavigate } from "react-router-dom";
import ManageReportsModal from "../components/ManagingReportsModel";
import "../styles/ReportingBottomToolbar.css";

const ReportingBottomToolbar = forwardRef(({
  studyId,

  reportId,

  reportName,
  onReportSelected,
  onReportNameChange,
  onOpenReport,
  onNewReportCreated,

  onSaveReport,

  onDownloadPrint,

  onSignOff,

  onViewRecordings,

  formats,

  selectedFormat,

  onTemplateChange,
  }, ref) => {
    const [showManageModal, setShowManageModal] = useState(false);
    const navigate = useNavigate();
    const [showPrintMenu, setShowPrintMenu] = useState(false);
    const handleNewReportCreated = (report) => {
        if (onNewReportCreated) {  
            onNewReportCreated(report);   
        }  
        setShowManageModal(false);
    };
    useImperativeHandle(ref, () => ({
      closeManageModal() {
          setShowManageModal(false);
      },
      openManageModal() {
          setShowManageModal(true);
      }
  }));
   const closeModel=()=>{
    setShowManageModal(false);
   }
    return (
      <div className="word-bottom-toolbar" style={{ display: "flex", alignItems: "center", gap: "10px", padding: "8px 16px", background: "#f5f5f5", borderTop: "1px solid #ccc", width: "100%", boxSizing: "border-box" }}>
        
        {/* ─── DYNAMIC FORMAT SELECTOR ─── */}
        <select 
          value={selectedFormat} 
          onChange={onTemplateChange} 
          className="format-search-input"
          style={{ cursor: "pointer" }}
        >
          <option value="">Select Report Format</option>
          {formats.map((item) => (
            <option key={item.id} value={item.id}>
              {item.description || `Format ${item.id}`}
            </option>
          ))}
        </select>
  
        <button className="btn-all"><span className="arrow">▼</span> ALL</button>
        <button className="btn-manage-formats"  onClick={() => navigate("/report-format")}>MANAGE FORMATS</button>
        
        <input 
          type="text" 
          value={reportName} 
          onChange={(e) => {
            if (onReportNameChange) {
                onReportNameChange(e.target.value);
            }
        }}
          style={{ 
            border: "none", 
            borderBottom: "1px solid #333", 
            background: "transparent", 
            padding: "4px 8px", 
            fontSize: "14px",
            minWidth: "150px" 
          }} 
        />
  
        <button className="btn-save-report" onClick={onSaveReport}>SAVE REPORT</button>
        <button className="btn-add-report" onClick={() => setShowManageModal(true)}>ADD REPORT</button>
        
        <div className="download-container">
    <button
        className="btn-download"
        onClick={() => setShowPrintMenu(!showPrintMenu)}
    >
        DOWNLOAD AND PRINT ▼
    </button>

    {showPrintMenu && (
        <div className="print-menu">
            <div
                className="print-menu-item"
                onClick={() => {
                    onDownloadPrint("print");
                    setShowPrintMenu(false);
                }}
            >
                Print
            </div>

            <div
                className="print-menu-item"
                onClick={() => {
                    onDownloadPrint("pdf");
                    setShowPrintMenu(false);
                }}
            >
                Download PDF
            </div>

            <div
                className="print-menu-item"
                onClick={() => {
                    onDownloadPrint("pdf-images");
                    setShowPrintMenu(false);
                }}
            >
                Download PDF With Images
            </div>

            <div
                className="print-menu-item"
                onClick={() => {
                    onDownloadPrint("word");
                    setShowPrintMenu(false);
                }}
            >
                Download Word
            </div>
        </div>
    )}
</div>
        <button className="btn-signoff" onClick={onSignOff}>SIGN OFF</button>
        <button className="btn-recordings" onClick={onViewRecordings}>VIEW RECORDINGS</button>
  
        {showManageModal && (
          <ManageReportsModal
          studyId={studyId}
          onClose={() => setShowManageModal(false)}
          onReportAdded={handleNewReportCreated}
          onReportSelected={onReportSelected}
          onOpenReport = {onOpenReport}
      />
        )}
      </div>
    );
  });
  export default ReportingBottomToolbar;